import React from 'react';

import Fields from 'ui/form/FieldsForm';
import Image from 'ui/form/Image';

export default function TeamPart({ errors, values, onChange }) {
    const changeFactory = name => value => onChange(name, value);
    const changeTeamLogo = blob => {
        onChange({
            logo: blob ? URL.createObjectURL(blob) : '',
            logoBlob: blob || '',
        });
    };
    return (
        <React.Fragment>
            <Fields.Text
                label="Business profile name"
                value={values.name}
                error={errors.name}
                onChange={changeFactory('name')}
            />
            <Image
                label="Business profile logo"
                color={values.color}
                name={values.business_name}
                value={values.logo}
                error={errors.logo}
                width={64}
                height={64}
                onChange={changeTeamLogo}
            />
        </React.Fragment>
    );
}
